import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-issue-brifly-datewise',
  templateUrl: './issue-brifly-datewise.component.html',
  styleUrl: './issue-brifly-datewise.component.scss'
})
export class IssueBriflyDatewiseComponent {
[x: string]: any;
  rep_name: any;
  off_rep_name: any;
  issue_date: any;
  issuenamewithdate: any;
  inDetailsRegReport1: any;
  advtamt: number;
  gstadvtamt: number;
  remaingtotal: number;
  totalpendingadvtamt: number;
  totaldisc_total: number;
  totalbefore_gst: number;
  total_pending: number;
  inDetailsRegReportrep: any;
  show: boolean;
  type: any;
  issue_cat: any;
  newissuedatepp: any;
  start_date: any;
  end_date: any;
  today1: any;
  inDetailsRegReportdatewise: any;
  advtamtb: any;
  totaladvtamt: any;
  totalbeforegst_amt: any;
  totalgst: any;
  netadvtamt: any;
  jamatotalb: any;
  jamatotal: any;

    constructor(
      private dialogref: MatDialogRef<IssueBriflyDatewiseComponent>,
      private datePipe: DatePipe,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService
    )
     {

     }

    ngOnInit(): void {

    this.type = this.data['type'];
      this.start_date = this.data['start_date'];
      this.end_date = this.data['end_date'];
      this.rep_name = this.data['rep_name'];
      this.off_rep_name = this.data['off_rep_name'];
      this.newissuedatepp = this.data['newissuedatepp'];
    
      this.issue_cat = this.data['issue_cat'] === undefined ? "ALL" : this.data['issue_cat'];
    
      // Extract only the date part (before first comma)
      const issueDateRaw = this.data['issueDates'];
      if (Array.isArray(issueDateRaw) && issueDateRaw.length > 0) {
        this.issue_date = issueDateRaw[0].split(',')[0];
      } else {
        this.issue_date = "ALL";
      }
    
      console.log("Final Payload Data:", {
        representativeId: this.rep_name,
        startDate: this.start_date,
        endDate: this.end_date,
        officeRepresentativeId: this.off_rep_name,
        issueNameId: this.issue_cat,
        issueSellerDate: this.issue_date
      });
      this.getReportData();
    }
  getReportData() {
  const req1: any = {
    start_date: this.start_date,
    end_date: this.end_date,
    rep_name: this.rep_name,
    off_rep_name: this.off_rep_name,
    issuename: this.issue_cat,
    issue_date: this.issue_date
  };

  this.service.getissueRegReportInDetailsdatewise(req1).subscribe((data) => {
    this.inDetailsRegReportdatewise = data;

    if (this.inDetailsRegReportdatewise.length > 0) {
      this.issuenamewithdate = this.inDetailsRegReportdatewise[0].issue_date;
    }

    // Reset all totals
   this.issueCopies = 0;
this.issue_amt = 0;
this.total_discounted_amt = 0;
this.total_before_gst = 0;
this.totalgst = 0;
this.netissueamt = 0;
this.jamatotal = 0;
this.total_pending = 0;

for (const item1 of this.inDetailsRegReportdatewise) {
  for (const item of item1.issue_data) {
    this.issueCopies += Number(item.issue_copies || 0);
    this.issue_amt += Number(item.issue_amt || 0);
    this.total_discounted_amt += Number(item.net_amount || 0);
    this.total_before_gst += Number(item.beforegst_amt || 0);
    this.totalgst += Number(item.gst || 0);
    this.netissueamt += Number(item.total_amount || 0);
    this.jamatotal += Number(item.pymt_rcv_amt || 0);
    this.total_pending += Number(item.remaining_amt || 0);
  }

    }

    // Optional: Log for debugging
    // console.log('Datewise Report:', this.inDetailsRegReportdatewise);
  });
}

  addFilters() {
    throw new Error('Method not implemented.');
  }
  getReportDatewise() {
    throw new Error('Method not implemented.');
  }
  printPage3() {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) {
      console.error("Print section not found!");
      return;
    }

    const printContent = printSection.innerHTML;

    const screenWidth = window.screen.availWidth;
    const windowWidth = 1500;
    const leftPosition = screenWidth - windowWidth - 50;

    const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        @media print {
                            @page {
                                size: A3 landscape;
                                margin: 3mm;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                font-size: 10px !important;
                                color: #000 !important; /* Ensure dark text */
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                            .print-section {
                                width: 100%;
                                margin: 0 auto;
                                padding: 0;
                            }
                            table {
                                width: 100% !important;
                                border-collapse: collapse !important;
                                border-spacing: 0 !important;
                                table-layout: auto;
                                page-break-inside: auto;
                                border: 2px solid #000 !important;
                            }
                            tr {
                                page-break-inside: avoid;
                                page-break-after: auto;
                            }
                            th, td {
                                padding: 3px 5px !important;
                                border: 1px solid #000 !important;
                                font-size: 10px !important;
                                line-height: 1.3;
                                word-wrap: break-word;
                                overflow-wrap: break-word;
                                color: #000 !important;
                            }
                            th {
                                background-color: #f2f2f2 !important;
                                font-weight: bold !important;
                                border-bottom: 2px solid #000 !important;
                            }
                            tr {
                                border-bottom: 1px solid #000 !important;
                            }
                            tr.header-row {
                                display: table-header-group !important;
                            }
                            td:nth-child(1) {
                                width: 1%;
                                text-align: left !important;
                                border-left: 1px solid #000 !important;
                            }
                            td:nth-child(2),
                            td:nth-child(3),
                            td:nth-child(4),
                            td:nth-child(5),
                            td:nth-child(6),
                            td:nth-child(8) {
                                text-align: left !important;
                            }
                            td:nth-child(5) {
                                width: 5%;
                                white-space: normal;
                            }
                            td.advt-name {
                                max-width: 160px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            td:nth-child(n+12),
                            td.amount,
                            td[data-type="number"] {
                                text-align: right !important;
                            }
                            td.text,
                            td[data-type="string"] {
                                text-align: left !important;
                            }
                            .br-right { border-right: 2px solid #000 !important; }
                            .br-rightt { border-right: 4px solid #000 !important; }
                            .br-bottom { border-bottom: 2px solid #000 !important; }
                            .br-top { border-top: 2px solid #000 !important; }
                            .noPrint { display: none !important; }
                            .footer-line {
                                position: fixed;
                                bottom: 0;
                                left: 0;
                                width: 100%;
                                height: 2px;
                                background-color: #000;
                                border-top: 2px solid #000 !important;
                            }
                            thead { 
                                display: table-header-group !important; 
                                border-bottom: 2px solid #000 !important;
                            }
                            tfoot { 
                                display: table-footer-group !important; 
                                border-top: 2px solid #000 !important;
                            }
                            td.balance-value {
                                text-align: right !important;
                                font-weight: bold !important;
                            }
                            /* Force all borders to be visible and dark */
                            table *, table *:before, table *:after {
                                border-color: #000 !important;
                                border-style: solid !important;
                                border-width: 1px !important;
                            }
                            /* Make sure header repeats on each page */
                            thead tr {
                                display: table-row !important;
                            }
                            /* Ensure table headers are bold and dark */
                            th {
                                font-weight: bold !important;
                                color: #000 !important;
                            }
                            /* Force print background colors */
                            * {
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                        }
                        
                        /* Screen styles (preview) */
                        @media screen {
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 20px;
                                font-size: 10px;
                                color: #000;
                            }
                            table {
                                border: 2px solid #000;
                            }
                            th, td {
                                border: 1px solid #000;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-section">
                        ${printContent}
                        <div class="footer-line"></div>
                    </div>
                    <script>
                        window.onload = function() {
                            const table = document.querySelector('table');
                            if (!table) {
                                console.error("Table not found");
                                return;
                            }
                            
                            // Apply borders forcefully to all cells
                            const allCells = document.querySelectorAll('th, td');
                            allCells.forEach(cell => {
                                cell.style.border = '1px solid #000 !important';
                                cell.style.color = '#000 !important';
                            });
                            
                            // Find and process header row
                            let headerRowIndex = -1;
                            const maxRowsToCheck = Math.min(10, table.rows.length);
                            
                            for (let i = 0; i < maxRowsToCheck; i++) {
                                const row = table.rows[i];
                                const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
                                
                                if (row.cells.length >= 8 &&
                                    (cellTexts.includes('Invoice No') ||
                                     cellTexts.includes('Receipt No') ||
                                     cellTexts.includes('Balance'))) {
                                    headerRowIndex = i;
                                    break;
                                }
                            }
                            
                            if (headerRowIndex >= 0) {
                                let thead = table.querySelector('thead');
                                if (!thead) {
                                    thead = document.createElement('thead');
                                    table.insertBefore(thead, table.firstChild);
                                }
                                
                                const headerRow = table.rows[headerRowIndex];
                                thead.appendChild(headerRow.cloneNode(true));
                            }
                            
                            // Alignment processing
                            const cells = document.querySelectorAll('td');
                            cells.forEach(cell => {
                                const content = cell.textContent.trim();
                                
                                if (content.includes('येणे') ||
                                    content.includes('Opening Balance') ||
                                    content.match(/^\\d+\\s+येणे$/) ||
                                    content.includes('Balance C/F') ||
                                    content.includes('Total')) {
                                    cell.style.textAlign = 'right';
                                    cell.classList.add('balance-value');
                                }
                                
                                const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                                if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                    cell.style.textAlign = 'right';
                                    cell.classList.add('amount');
                                }
                                
                                // Force borders and dark text
                                cell.style.border = '1px solid #000 !important';
                                cell.style.color = '#000 !important';
                            });
                            
                            setTimeout(() => {
                                window.print();
                                setTimeout(() => { window.close(); }, 500);
                            }, 500); // Increased delay for better rendering
                        };
                    </script>
                </body>
            </html>
        `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }
}